module.exports = __webpack_public_path__ + "static/final-1-4dbf4bb298e086ad05c384dc1a4bed05.png";